import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, LocationInfo } from 't4core';
import { DialogService } from '../../../../t4common';

@Component({
  selector: 'ServiceStatus',
  styleUrls: ['./ServiceStatus.css'],
  templateUrl: './ServiceStatus.html',
})
export class ServiceStatusComponent extends PageBase implements OnInit {
  public location: LocationInfo;
    

    constructor(el: ElementRef, private dialogSvc: DialogService) {
      super(el, "Support");
    }

  async ngOnInit() {

  }
}
